<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import CryptoJS from "crypto-js";
export default {
  name: "APP",
  data() {
    return {
      key: "u9dYuYlGVk39kkb5",
    };
  },
  created() {
    if (this.$route.query.zxCode) {
      const path = this.$route.path
      this.$axios
        .get(
          process.env.VUE_APP_API_DOMAIN +
          `/tbase-iam-service/iam/common/loginByThreeKey?principal=${this.$route.query.zxCode}&modelType=9`,
        )
        .then(res => {
          this.loginText = "登 录";
          let result = res.data;
          if (result.code === 200) {
            if (!result.data.userInfo.zcUserType.includes('gov')) return this.$router.push({ path: "/forbidden"});
            sessionStorage.setItem("access_token", result.data.accessToken);
            sessionStorage.setItem("userInfo", JSON.stringify(result.data.userInfo));
            sessionStorage.setItem("zc_code", result.data.userInfo.zcId);
            if (result.data.userInfo.roles && result.data.userInfo.roles.length) {
              let str =
                result.data.userInfo.roles.find(role => role.roleCode == "JG") || "";
              sessionStorage.setItem("isJG", str ? 1 : 0);
              let strGLLD = result.data.userInfo.roles.find(role => role.roleCode == "GLLD") || "";
              sessionStorage.setItem("strGLLD", strGLLD ? 1 : 0);
            } else {
              sessionStorage.setItem("isJG", 0);
              sessionStorage.setItem("strGLLD", 0);
            }
            
            if (path) {
              if (path.indexOf('login') == -1) {
                this.$router.push({
                  path: path
                });
              } else {
                this.$router.push({
                  path: "/Portal"
                });
              }
            } else {
              this.$router.push({
                path: "/Portal"
              });
            }
        
          } else {
            this.$message({
              message: result.msg,
              type: "warning"
            });
            this.$router.push({
              path: "/forbidden"
            });
          }
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue